import { clsx } from 'clsx';
import Link from '../../link/Link.mjs';
import { Typography } from '../propsValues/typography.mjs';
import { Priority } from '../propsValues/control.mjs';
import Button from '../../button/Button.resolver.mjs';
import { jsx } from 'react/jsx-runtime';

function Action({
  action,
  className,
  variant = 'button',
  sentiment = 'default',
  priority = Priority.SECONDARY
}) {
  if ('href' in action) {
    return /*#__PURE__*/jsx(Link, {
      href: action.href,
      className: className,
      "aria-label": action['aria-label'],
      target: action.target,
      type: Typography.LINK_LARGE,
      onClick: action.onClick,
      children: action.text
    });
  }
  switch (variant) {
    case 'action-button':
      return /*#__PURE__*/jsx(Button, {
        v2: true,
        size: "sm",
        sentiment: sentiment,
        "aria-label": action['aria-label'],
        priority: priority,
        className: clsx(className),
        onClick: action.onClick,
        children: action.text
      });
    case 'button':
    default:
      return /*#__PURE__*/jsx("button", {
        type: "button",
        "aria-label": action['aria-label'],
        className: clsx('btn-unstyled np-text-link-large', className),
        onClick: action.onClick,
        children: action.text
      });
  }
}

export { Action };
//# sourceMappingURL=Action.mjs.map
